/* eslint-disable @typescript-eslint/no-explicit-any */
import {useState, useEffect} from 'react';
import mqtt from 'mqtt';
import {mqttURL} from '../config';

let client = null as any;
let subscribedTopics = [] as string[];
const mqttOption = {
  keepalive: 30,
  protocolId: 'MQTT',
  protocolVersion: 4,
  clean: true,
  reconnectPeriod: 1000,
  connectTimeout: 30 * 1000,
};
const qos = 2;

const useMQTT = (topic: string) => {
  const [messages, setMessages] = useState<any>();
  useEffect(() => {
    if (!client) {
      client = mqtt.connect(mqttURL, mqttOption);
      client.on('error', (error: any) => {
        // handle the error
        console.error(error);
      });
      client.on('reconnect', () => {
        // handle the reconnection
        console.error('reconnected');
      });
    }

    if (!subscribedTopics.includes(topic) && topic.length > 0) {
      client.subscribe(topic, {qos: qos}, (error: any) => {
        if (!error) {
          subscribedTopics.push(topic);
        } else {
          // handle the error
          console.error('error in subscribtion', topic);
        }
      });
      client.on('message', (topic: any, message: string) => {
        // handle the message
        const x = JSON.parse(message).data;
        setMessages(x);
      });
    }

    return () => {
      if (subscribedTopics.includes(topic)) {
        client.unsubscribe(topic);
        subscribedTopics = subscribedTopics.filter((x) => x !== topic);
      }
    };
  }, [topic]);

  const publish = (topic: string, message: any) => {
    client.publish(topic, message);
  };

  return [messages, publish];
};

export default useMQTT;
